import React, { useState, useEffect } from "react";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import Rejected from "../../../assets/Icon/Rejected.png";
import PromoFile from "../../SuperStar/PromoVideo/PromoFile";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const RejectedPromoVideo = () => {
  const [loading, setLoading] = useState(true);
  const [event, setEvents] = useState([]);
  const [rejected, SetRejected] = useState("");

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/admin/promoVideoReject`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.promoVideos);
      }
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    axios.get(`/api/admin/promoVideoCount`).then((res) => {
      if (res.status === 200) {
        SetRejected(res.data.rejectTotal);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title={"Rejected Promo Video"}
        image={Rejected}
        count={rejected}
      />
      {loading === true ? (
        <LoaderPost />
      ) : (
        <PromoFile
          data={event}
          urlLink={`/superstar-admin/promoVideo/details`}
        />
      )}
    </>
  );
};

export default RejectedPromoVideo;
